module.exports = __webpack_public_path__ + "static/media/logo_icon.3577d477.png";